import { Box } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';

const scrollUp = keyframes`
  0% { transform: translate3d(0, 0, 0); }
  100% { transform: translate3d(0, -50%, 0); }
`;

export const Wrapper = styled(Box)`
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 64px;
    pointer-events: none;
    z-index: 1;
  }
  &::before {
    top: 0;
    background: linear-gradient(
      180deg,
      ${(p) => p.theme.palette.background.paper} 0%,
      transparent 100%
    );
  }
  &::after {
    bottom: 0;
    background: linear-gradient(
      0deg,
      ${(p) => p.theme.palette.background.paper} 0%,
      transparent 100%
    );
  }
`;

export const Grid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  height: 640px;
  overflow: hidden;

  ${(p) => p.theme.breakpoints.down('lg')} {
    grid-template-columns: repeat(2, 1fr);
    height: 720px;
  }
  ${(p) => p.theme.breakpoints.down('sm')} {
    grid-template-columns: 1fr;
    height: 560px;
  }
`;

export const Column = styled(Box)`
  position: relative;
  overflow: hidden;

  &:hover > * {
    animation-play-state: paused;
  }
`;

export const Track = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 14px;
  will-change: transform;
  animation: ${scrollUp} 70s linear infinite;

  &[data-col='1'] {
    animation-duration: 90s;
    animation-direction: reverse;
  }
  &[data-col='2'] {
    animation-duration: 80s;
  }
  &[data-col='3'] {
    animation-duration: 100s;
    animation-direction: reverse;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
